import { render, staticRenderFns } from "./ConfigFactorySetup.vue?vue&type=template&id=5f150302&scoped=true&"
import script from "./ConfigFactorySetup.vue?vue&type=script&lang=js&"
export * from "./ConfigFactorySetup.vue?vue&type=script&lang=js&"
import style0 from "./ConfigFactorySetup.vue?vue&type=style&index=0&id=5f150302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f150302",
  null
  
)

export default component.exports